export default __webpack_public_path__ + "static/media/logout.da38d18d.svg";